import { LitElement, html, css } from 'lit';

class PopupMessage extends LitElement {
    static styles = css`
    :host {
        display: none; /* 初期状態では非表示 */
      }

    :host([visible]) {
        display: block; /* visible属性がtrueの時に表示 */
    }

    .popup {
      position: relative;
      display: inline-block;
    }
    

    .popup .popup-text {
      font-size: 12px;
      background-color: black;
      color: #fff;
      text-align: center;
      border-radius: 6px;
      padding: 5px;
      position: absolute;
      z-index: 10;
      bottom: 10%;
      left: 50%;
      transform: translateX(-50%);
      white-space: pre-wrap;
      text-wrap: nowrap;
      padding-left: 20px;
      padding-right: 20px;
    }

    .popup:hover .popup-text {
      visibility: visible;
    }
  `;

    static properties = {
        message: { type: String },
        visible: { type: Boolean },
    };

    constructor() {
        super();
        this.message = 'popup text';
    }


    firstUpdated() {
        requestAnimationFrame(() => {
            const fontAwasomeStyle = document.querySelector(
                "link[rel='stylesheet'][data-name='fontawesomev6']"
            );
            const fontAwasomeStyleClone = fontAwasomeStyle.cloneNode(true);
            fontAwasomeStyleClone.removeAttribute('disabled');
            this.shadowRoot.insertBefore(fontAwasomeStyleClone, this.shadowRoot.firstChild);

            this.adjustPosition();
        })

    }

    // ポップアップの位置を調整するメソッド
    adjustPosition() {
        requestAnimationFrame(() => {
            const popupText = this.shadowRoot.querySelector('.popup-text');
            const popupTextRect = popupText.getBoundingClientRect();
            const viewportWidth = window.innerWidth;

            // 右側にはみ出している場合
            if (popupTextRect.right > viewportWidth) {
                popupText.style.left = 'auto';
                popupText.style.right = '0';
                popupText.style.transform = 'translateX(0)';
            }

            // 左側にはみ出している場合
            if (popupTextRect.left < 0) {
                popupText.style.left = '0';
                popupText.style.transform = 'translateX(0)';
            }
        });
    }

    updated(target) {
        if (target.has('visible')) {
            this.visible ? this.setAttribute('visible', '') : this.removeAttribute('visible');
        }
    }

    show() {
        this.visible = true;
        this.adjustPosition();
    }

    hide() {
        this.visible = false;
    }

    render() {
        return html`
      <span class="popup">
        <span class="popup-text">${this.message}</span>
      </span>
    `;
    }
}

customElements.define('popup-message-element', PopupMessage);